export default __webpack_public_path__ + "static/media/AppraisalWF5.6de8e22b.png";